import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/finally';

import { StatisticService } from '../../../../services/statistic.service';
import { Statistic } from '../../../../entities/statistic.entity';
import { Log } from '../../../../utils/index';

@Component({
  selector: 'app-dashboard-optiongroupedbydate',
  templateUrl: './dashboard-optiongroupedbydate.html'
})
export class DashboardOptionGroupedByDateComponent implements OnInit {
  stats: Observable<Statistic[]>;
  statType = 'activation';
  loading = false;

  constructor(protected statisticService: StatisticService) {}

  @Log()
  ngOnInit() {
      this.loadStats();
  }

  loadStats() {
    this.loading = true;
    if (this.statType === 'activation') {
      this.stats = this.statisticService.optionActivationStats().finally(() => this.loading = false);
    } else if (this.statType === 'activation_active') {
      this.stats = this.statisticService.optionActivationStats('active').finally(() => this.loading = false);
    } else if (this.statType === 'activation_canceled') {
      this.stats = this.statisticService.optionActivationStats('canceled').finally(() => this.loading = false);
    }
  }

  @Log()
  changeStatType(statType: string = null) {
    this.statType = statType;
    this.loadStats();
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/dashboard/optiongroupedbydate/dashboard-optiongroupedbydate.component.ts